export const userTypes = {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",
  LOGOUT: "LOGOUT",
  SAVE_PROFILE: "SAVE_PROFILE",
  LOADING: "LOADING",
  SET_CURRENCY: "SET_CURRENCY",
};
